import { api } from "@/lib/api"

export interface MaintenancePhoto {
  id: string
  issue_id: string
  url: string
  type: string
  uploaded_at: string
}

export interface MaintenanceIssue {
  id: string
  property_id?: string | null
  title: string
  description?: string | null
  category?: string | null
  priority: "low" | "medium" | "high" | "emergency"
  status: "open" | "in_progress" | "completed" | "cancelled"
  scheduled_date?: string | null
  completed_date?: string | null
  contractor_id?: string | null
  estimated_cost?: number | null
  actual_cost?: number | null
  currency?: string | null
  property?: { name?: string }
  contractor?: { name?: string }
  photos?: MaintenancePhoto[]
}

export interface Contractor {
  id: string
  name: string
  email?: string | null
  phone?: string | null
  speciality?: string | null
  notes?: string | null
}

export const maintenanceService = {
  async listIssues(property_id?: string): Promise<MaintenanceIssue[]> {
    const params = property_id ? { property_id } : {}
    const { data } = await api.get("/api/maintenance/issues", { params })
    return data.data
  },
  async getIssue(id: string): Promise<MaintenanceIssue> {
    const { data } = await api.get(`/api/maintenance/issues/${id}`)
    return data.data
  },
  async createIssue(input: Record<string, unknown>): Promise<MaintenanceIssue> {
    const { data } = await api.post("/api/maintenance/issues", input)
    return data.data
  },
  async updateIssue(id: string, input: Record<string, unknown>): Promise<MaintenanceIssue> {
    const { data } = await api.put(`/api/maintenance/issues/${id}`, input)
    return data.data
  },
  async deleteIssue(id: string): Promise<void> {
    await api.delete(`/api/maintenance/issues/${id}`)
  },

  async uploadPhotos(issueId: string, files: File[]): Promise<MaintenancePhoto[]> {
    const formData = new FormData()
    files.forEach((f) => formData.append("photos", f))
    const { data } = await api.post(`/api/maintenance/issues/${issueId}/photos`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    return data.data
  },

  async deletePhoto(issueId: string, photoId: string): Promise<void> {
    await api.delete(`/api/maintenance/issues/${issueId}/photos/${photoId}`)
  },

  async listContractors(): Promise<Contractor[]> {
    const { data } = await api.get("/api/contractors")
    return data.data
  },
  async createContractor(input: Record<string, unknown>): Promise<Contractor> {
    const { data } = await api.post("/api/contractors", input)
    return data.data
  },
  async updateContractor(id: string, input: Record<string, unknown>): Promise<Contractor> {
    const { data } = await api.put(`/api/contractors/${id}`, input)
    return data.data
  },
  async deleteContractor(id: string): Promise<void> {
    await api.delete(`/api/contractors/${id}`)
  },
}
